/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
// Lib dependencies
import { Clock, ClipboardCheck, Plus } from 'lucide-react';
import { CalendarIcon } from 'lucide-react';
import NiceModal from '@ebay/nice-modal-react';
import { useTranslation } from 'react-i18next';

// Components
import { Button } from '@/components/UI/Button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/UI/Tabs';
import AddMeetingModal from './components/AddMeetingModal';
import UpcomingMeetings from './components/UpcomingMeetings/UpcomingMeetings';
import CompletedMeetings from './components/CompletedMeetings/CompletedMeetings';
import CanceledMeetings from './components/CanceledMeetings/CanceledMeetings';

// Types
import { MeetingStatus } from '@/types/meeting';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */

export default function Meetings() {
  const { t } = useTranslation();

  return (
    <div className="">
      <h1 className="text-4xl font-bold mb-8 text-background-1">
        {t('pages.meetings.my_meetings')}
      </h1>

      <div className="mb-6">
        <Button
          variant="primary"
          onClick={() => NiceModal.show(AddMeetingModal)}
        >
          <Plus className="mr-2 h-4 w-4" />
          {t('pages.meetings.take_a_meeting')}
        </Button>
      </div>
      <div className="bg-white rounded-2xl shadow-sm p-6 mb-8">
        <Tabs defaultValue={MeetingStatus.COMING} className="w-full">
          <TabsList className="grid w-full grid-cols-3 bg-background-1 rounded-t-lg mb-6">
            <TabsTrigger
              value={MeetingStatus.COMING}
              className="text-white hover:bg-primary hover:text-background-1 transition-colors items-center gap-x-2"
            >
              <CalendarIcon className="h-5 w-5" />
              {t('global.upcoming')}
            </TabsTrigger>
            <TabsTrigger
              value={MeetingStatus.DONE}
              className="text-white hover:bg-primary hover:text-background-1 transition-colors items-center gap-x-2"
            >
              <ClipboardCheck className="h-4 w-4" />
              {t('global.completed_and_report')}
            </TabsTrigger>
            <TabsTrigger
              value={MeetingStatus.CANCELED}
              className="text-white hover:bg-primary hover:text-background-1 transition-colors items-center gap-x-2"
            >
              <Clock className="h-4 w-4" />
              {t('global.canceled')}
            </TabsTrigger>
          </TabsList>
          <TabsContent value={MeetingStatus.COMING}>
            <UpcomingMeetings />
          </TabsContent>
          <TabsContent value={MeetingStatus.DONE}>
            <CompletedMeetings />
          </TabsContent>
          <TabsContent value={MeetingStatus.CANCELED}>
            <CanceledMeetings />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
}
